import { render, staticRenderFns } from "./PlanCarrierLinks.vue?vue&type=template&id=054a4e0a&lang=pug"
import script from "./PlanCarrierLinks.vue?vue&type=script&lang=js"
export * from "./PlanCarrierLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports